import React, { Component } from "react";
import { Link } from "react-router-dom";

export class Sidebar8 extends Component {
  render() {
    return (
      <div>
        <div className="widget widget-nav-menu">
          <ul className="widget-menu">
            <li>
              <Link
                activeClassName="active"
                to={process.env.PUBLIC_URL + "/monday-work-management"}
              >
                Monday Work Management
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/monday-crm"}>
               Monday CRM
              </Link>
            </li>

             <li>
              <Link to={process.env.PUBLIC_URL + "/monday-dev"}>
               Monday Dev
              </Link>
            </li>

             <li>
              <Link to={process.env.PUBLIC_URL + "/monday-service"}>
              Monday Service
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar8;
